module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-form-container"
  }, [_c('form', {
    staticClass: "login-form",
    attrs: {
      "novalidate": ""
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login.apply(null, arguments)
      }
    }
  }, [_c('md-input-container', {
    class: {
      'md-input-invalid': _vm.emailError() || _vm.userNotFoundError()
    }
  }, [_c('label', {
    attrs: {
      "for": "email-input"
    }
  }, [_vm._v("Email Address")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "id": "email-input",
      "type": "email",
      "required": ""
    },
    on: {
      "blur": _vm.validateEmail
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }), _vm._v(" "), (_vm.emailError()) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v("\n                " + _vm._s(_vm.errorMessage) + " \n                "), (_vm.verifyError && !_vm.sent && _vm.email) ? _c('a', {
    staticClass: "send-verification-email",
    on: {
      "click": _vm.sendVerficationEmail
    }
  }, [_vm._v("\n                    Send Verification Email\n                ")]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), (_vm.userNotFoundError()) ? _c('div', {
    staticClass: "error-user-not-found"
  }, [_c('md-icon', {
    staticClass: "error-icon"
  }, [_vm._v("error_outline")]), _vm._v(" "), _c('span', [_vm._v("The email address you have entered is not currently in our system. If you are a new user, please click on the 'Create Account' button below.")])], 1) : _vm._e(), _vm._v(" "), _c('md-input-container', {
    class: {
      'md-input-invalid': _vm.passwordError()
    }
  }, [_c('label', {
    attrs: {
      "for": "password-input"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "id": "password-input",
      "type": _vm.showCurrentPassword ? 'text' : 'password',
      "required": ""
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "toggle-password",
    on: {
      "click": function($event) {
        return _vm.toggleShowPassword('current')
      }
    }
  }, [_c('md-icon', [_vm._v(_vm._s(_vm.showCurrentPassword ? 'visibility' : 'visibility_off'))])], 1), _vm._v(" "), (_vm.passwordError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e()], 1), _vm._v(" "), (_vm.generalErrorMessage) ? _c('p', {
    staticClass: "signin-error",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v(_vm._s(_vm.generalErrorMessage))]) : _vm._e(), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary login-button",
    attrs: {
      "disabled": _vm.loading || !_vm.isFormValid
    },
    on: {
      "click": _vm.login
    }
  }, [(_vm.loading) ? _c('md-spinner', {
    staticClass: "md-accent",
    attrs: {
      "md-size": 20
    }
  }) : _c('span', [_vm._v("Sign In")])], 1), _vm._v(" "), _c('div', {
    staticClass: "links-below"
  }, [_c('div', {
    staticClass: "forgot-password-link"
  }, [_c('md-button', {
    attrs: {
      "disabled": _vm.loading,
      "flat": ""
    },
    on: {
      "click": _vm.forgot
    }
  }, [_vm._v("\n                    Forgot Password?\n                ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "register-link"
  }, [_c('span', [_vm._v("Don't have an account?")]), _vm._v(" "), _c('md-button', {
    staticClass: "create-account-link",
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.toggleRegister
    }
  }, [_vm._v("\n                    Create Account\n                ")])], 1)])], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "loginDialog",
    attrs: {
      "md-title": _vm.confirm.title,
      "md-content-html": _vm.getConfirmContent(),
      "md-ok-text": _vm.confirm.ok,
      "md-cancel-text": _vm.confirm.cancel
    },
    on: {
      "close": _vm.onDialogClose
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17123522","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/login-form.vue
// module id = 1207
// module chunks = 21